import styled from "styled-components";
import { colors } from "../../../assets";

export const DebtRecoveryContainer = styled.div`
  .filter-row {
    display: flex;
    justify-content: space-between;
    gap: 20px;
  }

  .title-row {
    display: flex;
    justify-content: space-between;
  }

  .left-info-modal-main-content {
    .left-info-modal-button {
      .ghost {
        background-color: #fff;
        border: 1px solid ${colors["PR-001-80"]} !important;
        color: ${colors["PR-001-80"]} !important;

        &:hover {
          background-color: #fff;
          border: 1px solid ${colors["PR-001-100"]} !important;
          color: ${colors["PR-001-100"]} !important;
        }
      }
    }
  }
`;

export const SectionContainer = styled.section`
  width: 100%;
  margin: 20px 0;

  .button-container {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 20px;
  }
`;
